import Vue from 'vue'

Vue.directive('phoneNumberInput', {
  update(el) {
    let strNumber = el.value
    if (strNumber !== null || strNumber !== '') {
      el.value = strNumber.replace(/[^\d\\-]/g, '')
    }
  }
})
